// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthShell {
  position: fixed;
  inset: 0;
  overflow: hidden;
}
.AuthShell__bg {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
  animation: auth-shell-drift 45s ease-in-out infinite alternate;
  will-change: transform;
}
.AuthShell__card {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 8px;
  display: flex;
  flex-direction: column;
  width: clamp(768px, 44vw + 317.44px, 856px);
  border-radius: 16px;
  box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  animation: auth-shell-card-in 480ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.AuthShell__back {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 10;
}
.AuthShell__content {
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  padding: 20px 48px;
}
.AuthShell__inner {
  width: 100%;
  max-width: 400px;
  margin: auto;
}
.AuthShell__step {
  animation: auth-shell-step-in 320ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.AuthShell input:-webkit-autofill,
.AuthShell input:-webkit-autofill:hover,
.AuthShell input:-webkit-autofill:focus,
.AuthShell input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-text-fill-color: #181d27;
  caret-color: #181d27;
}
.AuthShell--dark input:-webkit-autofill,
.AuthShell--dark input:-webkit-autofill:hover,
.AuthShell--dark input:-webkit-autofill:focus,
.AuthShell--dark input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #22262f inset !important;
  -webkit-text-fill-color: #fff;
  caret-color: #fff;
}
.AuthShell input:-webkit-autofill {
  animation-name: auth-shell-autofill;
  animation-duration: 1ms;
}
.AuthShell input:autofill {
  animation-name: auth-shell-autofill;
  animation-duration: 1ms;
}

.AuthPop {
  animation: auth-shell-pop 220ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes auth-shell-card-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes auth-shell-step-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes auth-shell-drift {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.06);
  }
}
@keyframes auth-shell-autofill {
  from {
    opacity: 1;
  }
}
@keyframes auth-shell-pop {
  from {
    opacity: 0;
    transform: scale(0.4);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .AuthShell__bg,
  .AuthShell__card,
  .AuthShell__step,
  .AuthPop {
    animation: none !important;
  }
}
@media (min-width: 1920px) {
  .AuthShell__card {
    width: min(100vw - 864px, 1200px);
  }
}
@media (min-width: 1312px) and (max-width: 1919.98px) {
  .AuthShell__card {
    width: min(100vw - 456px, 1056px);
  }
}
@media (min-width: 1440px) {
  .AuthShell__content {
    padding: 20px 72px;
  }
}
@media (min-width: 600px) and (max-width: 1023.98px) {
  .AuthShell__card {
    width: min(100vw - 16px, 768px);
  }
  .AuthShell__content {
    padding: 20px 24px;
  }
}
@media (max-width: 599.98px) {
  .AuthShell__bg {
    bottom: auto;
    height: calc(min(22vh, 184px) + 24px);
  }
  .AuthShell__card {
    top: min(22vh, 184px);
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 16px 16px 0 0;
    box-shadow: none;
  }
  .AuthShell__content {
    padding: 16px 16px 24px;
  }
  .AuthShell__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0 auto;
  }
  .AuthShell__step {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared/AuthShell/lib/AuthShell.scss"],"names":[],"mappings":"AAUA;EACE,eAAA;EACA,QAAA;EACA,gBAAA;AATF;AAWE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,8DAAA;EACA,sBAAA;AATJ;AAYE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,sEAAA;AAVJ;AAaE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAXJ;AAcE;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAZJ;AAeE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAbJ;AAiBE;EACE,sEAAA;AAfJ;AAsBE;;;;EAIE,sDAAA;EACA,gCAAA;EACA,oBAAA;AApBJ;AAwBI;;;;EAIE,yDAAA;EACA,6BAAA;EACA,iBAAA;AAtBN;AA+BE;EACE,mCAAA;EACA,uBAAA;AA7BJ;AAgCE;EACE,mCAAA;EACA,uBAAA;AA9BJ;;AAmCA;EACE,kEAAA;AAhCF;;AAmCA;EACE;IACE,UAAA;IACA,2BAAA;EAhCF;EAmCA;IACE,UAAA;IACA,eAAA;EAjCF;AACF;AAoCA;EACE;IACE,UAAA;IACA,2BAAA;EAlCF;EAqCA;IACE,UAAA;IACA,eAAA;EAnCF;AACF;AAsCA;EACE;IACE,mBAAA;EApCF;EAuCA;IACE,sBAAA;EArCF;AACF;AA0CA;EACE;IACE,UAAA;EAxCF;AACF;AA2CA;EACE;IACE,UAAA;IACA,qBAAA;EAzCF;EA4CA;IACE,UAAA;IACA,mBAAA;EA1CF;AACF;AA6CA;EACE;;;;IAIE,0BAAA;EA3CF;AACF;AA8CA;EACE;IACE,iCAAA;EA5CF;AACF;AA+CA;EACE;IACE,iCAAA;EA7CF;AACF;AAgDA;EACE;IACE,kBAAA;EA9CF;AACF;AAmDA;EACE;IACE,+BAAA;EAjDF;EAoDA;IACE,kBAAA;EAlDF;AACF;AAuDA;EAIE;IACE,YAAA;IACA,qCAAA;EAxDF;EA2DA;IACE,qBAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,4BAAA;IACA,gBAAA;EAzDF;EA4DA;IACE,uBAAA;EA1DF;EA6DA;IACE,aAAA;IACA,sBAAA;IACA,YAAA;IACA,cAAA;EA3DF;EA8DA;IACE,YAAA;EA5DF;AACF","sourcesContent":["// Login 2.0 shell — the card is always pinned left inside an 8px frame and\n// the background expands on the right. Widths anchor to the Figma responsive\n// frames (\"600 - 1023\", \"1024 - 1279\", \"1440 - 1919\", \"1920+\" — caps\n// 768/856/1056/1200, 448px right reserve on the xl ramp) but the function is\n// piecewise-linear and CONTINUOUS at every boundary so nothing jumps while\n// resizing: 100vw-16 → 768 @784 → ramp to 856 @1224 → hold → 100vw-456 from\n// 1312 → 1056 @1512 → hold → 100vw-864 from 1920 → 1200 @2064. Disjoint media\n// ranges are used on purpose: the project's Tailwind screens are desktop-first\n// `max:` queries with a broken sort order, so responsive width utilities can\n// silently resolve wrong (see Container).\n.AuthShell {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n\n  &__bg {\n    position: absolute;\n    inset: 0;\n    background-position: center;\n    background-size: cover;\n    animation: auth-shell-drift 45s ease-in-out infinite alternate;\n    will-change: transform;\n  }\n\n  &__card {\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    display: flex;\n    flex-direction: column;\n    width: clamp(768px, 44vw + 317.44px, 856px);\n    border-radius: 16px;\n    box-shadow: 2px 4px 15px rgb(0 0 0 / 10%);\n    overflow-y: auto;\n    animation: auth-shell-card-in 480ms cubic-bezier(0.16, 1, 0.3, 1) both;\n  }\n\n  &__back {\n    position: absolute;\n    top: 24px;\n    left: 24px;\n    z-index: 10;\n  }\n\n  &__content {\n    display: flex;\n    flex: 1 0 auto;\n    width: 100%;\n    padding: 20px 48px;\n  }\n\n  &__inner {\n    width: 100%;\n    max-width: 400px;\n    margin: auto;\n  }\n\n  // Keyed step wrapper (AuthTransition): fade + rise on every step change.\n  &__step {\n    animation: auth-shell-step-in 320ms cubic-bezier(0.16, 1, 0.3, 1) both;\n  }\n\n  // Autofill restyle. The global reset (_reset.scss) forces a white inset\n  // cover over autofilled inputs with !important — these rules must match its\n  // importance and pseudo-states so the higher specificity here wins, and the\n  // dark theme can paint the field its own background instead of a white pill.\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\n    -webkit-text-fill-color: #181d27; // neutral-900\n    caret-color: #181d27;\n  }\n\n  &--dark {\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    input:-webkit-autofill:active {\n      -webkit-box-shadow: 0 0 0 1000px #22262f inset !important; // neutral-dark-800\n      -webkit-text-fill-color: #fff;\n      caret-color: #fff;\n    }\n  }\n\n  // Silent-autofill detection (useAutofilledFields): browsers fill saved\n  // credentials without firing change events, so this no-op animation is the\n  // only reliable signal a field was filled. Separate rules on purpose — one\n  // unrecognized selector in a shared list would drop the whole rule. Must NOT\n  // be disabled under prefers-reduced-motion.\n  input:-webkit-autofill {\n    animation-name: auth-shell-autofill;\n    animation-duration: 1ms;\n  }\n\n  input:autofill {\n    animation-name: auth-shell-autofill;\n    animation-duration: 1ms;\n  }\n}\n\n// Scale-in for small state changes (e.g. the password checklist checkmarks).\n.AuthPop {\n  animation: auth-shell-pop 220ms cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n@keyframes auth-shell-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes auth-shell-step-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes auth-shell-drift {\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.06);\n  }\n}\n\n// No visual effect — exists only so animationstart fires on autofilled inputs\n// (see useAutofilledFields).\n@keyframes auth-shell-autofill {\n  from {\n    opacity: 1;\n  }\n}\n\n@keyframes auth-shell-pop {\n  from {\n    opacity: 0;\n    transform: scale(0.4);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .AuthShell__bg,\n  .AuthShell__card,\n  .AuthShell__step,\n  .AuthPop {\n    animation: none !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .AuthShell__card {\n    width: min(calc(100vw - 864px), 1200px);\n  }\n}\n\n@media (min-width: 1312px) and (max-width: 1919.98px) {\n  .AuthShell__card {\n    width: min(calc(100vw - 456px), 1056px);\n  }\n}\n\n@media (min-width: 1440px) {\n  .AuthShell__content {\n    padding: 20px 72px;\n  }\n}\n\n// Tablet: the card fills the viewport inside a uniform 8px frame; past the\n// 768px cap it stays pinned left and the background expands on the right.\n@media (min-width: 600px) and (max-width: 1023.98px) {\n  .AuthShell__card {\n    width: min(calc(100vw - 16px), 768px);\n  }\n\n  .AuthShell__content {\n    padding: 20px 24px;\n  }\n}\n\n// Mobile: background band on top, sheet slides up from the bottom with rounded\n// top corners (the logo renders inside the card via AuthHeader).\n@media (max-width: 599.98px) {\n  // Scope the hero image to the top band (plus overlap for the sheet's rounded\n  // corners) so `cover` fits the whole composition — stripes AND leaves — into\n  // the band like the Figma frames.\n  .AuthShell__bg {\n    bottom: auto;\n    height: calc(min(22vh, 184px) + 24px);\n  }\n\n  .AuthShell__card {\n    top: min(22vh, 184px);\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    border-radius: 16px 16px 0 0;\n    box-shadow: none;\n  }\n\n  .AuthShell__content {\n    padding: 16px 16px 24px;\n  }\n\n  .AuthShell__inner {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    margin: 0 auto;\n  }\n\n  .AuthShell__step {\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
